import React, { useState } from 'react';

const SettingsManagement = ({ settings, updateSetting, removeSetting }) => {
    console.log("settings", settings);
    console.log("settingsss", settings?.settings);
/* {
    "w95_buffer_afrr_minimum": {
        "category": "aFRR settings",
        "label": "W95 Buffer lower limit before aFRR [0 to 1]",
        "role": "operator",
        "description": "W95 Buffer lower limit before aFRR"
    },
    "afrr_revenue_share": {
        "category": "aFRR settings",
        "label": "aFRR revenue share of reservation [0 to 1]",
        "role": "operator",
        "description": "aFRR revenue share of reservation"
    }
} */
    // Initialize localSettings with an empty object to avoid conditional hook call
    const [localSettings, setLocalSettings] = useState(
        Object.fromEntries(
            Object.entries(settings?.settings || {}).map(([key, value]) => [key, JSON.stringify(value)])
        )
    );

    // Check if settings and settings.settings are defined
    if (!settings?.settings) {
        return <div>No settings found</div>;
    }

    let settingsList = Object.keys(settings.settings);

    const handleInputChange = (key, value) => {
        setLocalSettings({
            ...localSettings,
            [key]: value
        });
    };

    const handleUpdate = (key) => {
        try {
            const parsedValue = JSON.parse(localSettings[key]);
            updateSetting(key, parsedValue);
        } catch (error) {
            console.error("Invalid JSON format", error);
        }
    };

    return (
        <div className="settings-container">
            {settingsList.map((setting) => (
                <div key={setting} className="settings-block">
                    <h3>{setting}</h3>
                    <p>{JSON.stringify(settings.settings[setting])}</p>
                    <textarea
                        className="large-input"
                        value={localSettings[setting]}
                        onChange={(e) => handleInputChange(setting, e.target.value)}
                    />
                    <button onClick={() => handleUpdate(setting)}>Update</button>
                </div>
            ))}
        </div>
    );
};

export default SettingsManagement; 